import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Button } from 'ui-components/Button'
import { DialogContent, DialogActions } from './styles'

export default function Confirm(props) {
  const {
    open,
    title,
    children,
    onCancel,
    onConfirm,
    cancelButtonText,
    confirmButtonText,
    type,
    requesting,
  } = props

  let buttonColor = 'primary'
  if (type === 'warning') {
    buttonColor = 'secondary'
  }

  const renderSpinner = () => (
    <CircularProgress size="16px" color="inherit" />
  )

  return (
    <Dialog open={open}>
      <DialogTitle>
        <strong>{title}</strong>
      </DialogTitle>

      <DialogContent>
        {children}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onCancel}
          disabled={requesting}
        >
          {cancelButtonText}
        </Button>
        <Button
          onClick={onConfirm}
          color={buttonColor}
          disabled={requesting}
        >
          { requesting ? renderSpinner() : null }
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

Confirm.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
  ]),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  type: PropTypes.string,
  requesting: PropTypes.bool,
}

Confirm.defaultProps = {
  open: false,
  title: '',
  children: '',
  cancelButtonText: 'Cancelar',
  confirmButtonText: 'Confirmar',
  type: 'default',
  requesting: false,
}
